import { render, staticRenderFns } from "./TestingOfAiSheathPage.vue?vue&type=template&id=52a5501c&scoped=true&"
import script from "./TestingOfAiSheathPage.vue?vue&type=script&lang=js&"
export * from "./TestingOfAiSheathPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a5501c",
  null
  
)

export default component.exports